module.exports = __webpack_public_path__ + "static/04-b6120885ff393ab910dfffe0e67e2078.jpg";